<template>
  <div>
    <h1>rowClicked </h1>
  </div>
</template>
<script>
import firebase from "firebase";
// const db = firebase.firestore();
export default {
  data() {
    return {
        datacame:""
    };
  },
  methods: {
    gettokens() {
    //   this.tableData = [];
      const db = firebase.firestore();
      db.collection("users")
        .doc(this.id)
        .get()
        .then((snapshot) => {
            console.log("datacame", snapshot.data())
            this.datacame= snapshot.data();
        });
    },
  },
  created() {
    this.id = this.$route.params.id;
    console.log("id received", this.id);
    this.gettokens();
  },
};
</script>